import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step9 } from '../../../../../shared/models/component-messages/mapaIN/step9';
import { FormUtilsService } from '../../../../../shared/services/form-utils.service';
import { LogService } from '../../../../../shared/services/log.service';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { Initial } from '../../models/Initial';

@Component({
  selector: 'app-step9',
  templateUrl: './step9.component.html'
})
export class Step9Component implements OnInit {

  private LOG: LogService = new LogService(Step9Component);

	@Input() initial: Initial;

	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;

	

	@Input() uid = '';


	public step9 = new Step9();

	@Input() linkForRouter: string;

	constructor(
		public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
		private formUtilsService: FormUtilsService
	) { }


  ngOnInit(): void {
  }

  public getUid() {
		return this.uid;
	}

}
